import React, { useEffect, useState, useRef } from "react";
import WidgetHeader from "../../../../components/Widget/Header";
import { FormattedDate, FormattedTime } from 'react-intl'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import 'github-markdown-css'

const NewsWidget = ({ widget }) => {
  const mounted = useRef(false);
  const [title, setTitle] = useState("");
  const [announcements, setAnnouncements] = useState([]);

  useEffect(() => {
    mounted.current = true;
    fetch('supplierdashboard/News')
    .then((response) => response.json())
    .then(({data}) => {
      if (mounted.current) {
        setAnnouncements(data.announcements);
      }
    });
    setTitle(widget.widgetId.replace(/_/g, " "));

    return () => {
      mounted.current = false;
    };
  }, []);

  const getDateFormatted = (date) => {
    const value = new Date(date)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const widget_id = `ID_${widget.widgetId}`;
  return (
    <li
      className="bg-white border m-4 shadow rounded border-gray-400"
      key={widget_id}
      id={widget_id}
    >
      <WidgetHeader widget={widget} widgetTitle={title} />
      <div>
        {announcements.map((announcement) => (
          <article className="border-b p-4">
            <div className="flex justify-between items-center">
              <h2 className="font-semibold">{announcement.title}</h2>
              {getDateFormatted(announcement.created_at)}
            </div>
            <div className="markdown-body">
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                children={announcement.body}
              />
            </div>
          </article>
        ))}
      </div>
    </li>
  );
};

export default NewsWidget;
